module.exports = __webpack_public_path__ + "static/media/family-friends-active.9a8e7b18.svg";